import React, { Component, Fragment } from 'react';
import { mapContextParamsToPageEvent } from '@bit/gerenciatd.utils.context';
import { convertPathToPageName } from '@bit/gerenciatd.utils.metrics';
import PingCmsPage from '@bit/gerenciatd.utils.ping-cms-page';
import PropTypes from 'prop-types';
import MetaData from './MetaData';

let lastPageObserverName = '';

class Page extends Component {
  constructor(props) {
    super(props);
    const {
      pageId,
      seoCustomValue,
      projectId,
      isBuyProcess,
      match,
      context,
    } = props;

    /* We need to know if this page is about a specific product */
    let pageWithExtraInfo = false;
    if (
      (props.match
        && props.match.params
        && Object.keys(props.match.params).length > 0)
      || isBuyProcess
    ) {
      pageWithExtraInfo = true;
    }

    try {
      this.resetObservers();
    } catch (error) {
      console.log({ error });
    }

    lastPageObserverName = `App-${projectId}-Page-Observer`;

    this.metricsControl = {
      /* información */
      projectId,
      pageId,
      segment: context.pageSegment,
      match,
      // soy un proceso de compra
      isBuyProcess,
      // necesito evento para pintar printed
      pageWithExtraInfo,
      extraPageInfo: null,
      seoCustomValue,
      /* Eventos */
      view: false, // page view
      viewData: null,
      print: false,
      printData: null,
      loaded: false,
      loadedData: null,
      update: false,
      queueName: 'Metrics',
      fullPagePrint: null,
    };
  }

  checkFullLoadedPage = () => {
    const { projectId } = this.metricsControl;
    const queueName = 'AppController-PageLoaded';
    const observerName = `${projectId}-LOADED`;

    window.nookInfoExchange.registerAsObserver(
      queueName,
      observerName,
      (loadedData) => {
        window.nookInfoExchange.cleanObserver(queueName, observerName);
        this.metricsControl.loadedData = loadedData;
        this.loadedEventPage();
      },
    );
  };

  checkExtraPageInfo = () => {
    const { projectId } = this.metricsControl;
    window.nookInfoExchange.registerAsObserver(
      'AppController-ExtraPageInfo',
      `${projectId}-EXTRAPAGEINFO`,
      (extraPageInfo) => {
        this.cleanExtraPageInfoObserver();
        this.metricsControl.extraPageInfo = extraPageInfo;
        this.printEventHandler();
      },
    );
  };

  checkFullPagePrint = () => {
    // interval to have printTimie
    this.fullPagePrint = setInterval(() => {
      let { fullPagePrint } = this;
      const { timing } = window.performance;
      if (fullPagePrint) {
        const renderMs = timing.domComplete - timing.domLoading;
        const resultTime = Math.round(renderMs / 100) / 10;
        if (resultTime && resultTime > 0) {
          // it means we kille interval
          clearInterval(fullPagePrint);
          fullPagePrint = resultTime;
          this.metricsControl.printTime = fullPagePrint;
          this.printEventHandler();
        }
      }
    }, 1000);
  };

  buildViewData = (data) => {
    let { 'user-type': userType } = data;
    let contextUserRole = '';
    if (userType === 'Gestor') {
      userType = 'Telco';
      contextUserRole = 'gestor';
    }
    return {
      ...data,
      'context-user-role': contextUserRole,
      'user-type': userType,
    };
  };

  pageEventsHandler = (data) => {
    // CMS-PAGE-VIEW = (COMMON PAGE INFO)
    const { view } = this.metricsControl;

    this.metricsControl.viewData = {
      ...this.buildViewData(data),
      event: 'cms-page',
      'event-type': 'view',
    };
    // montar el pagename solo si isBuyProcess
    const { isBuyProcess, extraPageInfo } = this.metricsControl;

    if (extraPageInfo) {
      this.metricsControl.viewData = {
        ...this.metricsControl.viewData,
        ...extraPageInfo,
      };
    }

    if (isBuyProcess) {
      this.metricsControl.viewData = {
        ...this.metricsControl.viewData,
        'page-name': convertPathToPageName(),
      };
    }

    if (document && document.location && document.location.href) {
      this.metricsControl.viewData['context-url'] = document.location.href;
    }
    // si no hemos enviado evento y tenemos los datos preparados => enviamos
    if (!view) {
      window.nookInfoExchange.sendMessage(
        this.metricsControl.queueName,
        this.metricsControl.viewData,
      );
      this.metricsControl.view = true;
      return null;
    }
    // CMS-PAGE-UPDATE
    // only if we dont have send any event
    const { update, print, printData } = this.metricsControl;
    if (!update && print) {
      this.metricsControl.updateData = {
        ...printData,
        'event-type': 'update',
      };
      window.nookInfoExchange.sendMessage(
        this.metricsControl.queueName,
        this.metricsControl.updateData,
      );
      this.metricsControl.update = true;
      return null;
    }

    return null;
  };

  printEventHandler = () => {
    // CMS-PAGE-PRINTED
    const { print, viewData } = this.metricsControl;
    const { printTime, extraPageInfo, pageWithExtraInfo } = this.metricsControl;
    if (
      !print
      && printTime > -1
      && viewData
      && (extraPageInfo || !pageWithExtraInfo)
    ) {
      this.metricsControl.printData = {
        ...viewData,
        ...extraPageInfo,
        event: 'cms-page',
        'event-type': 'printed',
        'full-page-print': printTime,
      };
      window.nookInfoExchange.sendMessage(
        this.metricsControl.queueName,
        this.metricsControl.printData,
      );
      this.metricsControl.print = true;
    }
  };

  loadedEventPage = () => {
    // CMS-PAGE-LOADED => TODOS LOS RECURSOS ESTAN CARGADOS
    const { loaded, print, printData } = this.metricsControl;
    if (print && !loaded) {
      this.metricsControl.loadedData = {
        ...printData,
        event: 'cms-page',
        'event-type': 'loaded',
      };
      window.nookInfoExchange.sendMessage(
        this.metricsControl.queueName,
        this.metricsControl.loadedData,
      );
      this.metricsControl.loaded = true;
    }
  };

  checkPageChanges = () => {
    mapContextParamsToPageEvent(lastPageObserverName, (data) => {
      this.pageEventsHandler(data);
    });
  };

  cleanExtraPageInfoObserver = () => {
    const { projectId } = this.props;
    window.nookInfoExchange.cleanObserver(
      'AppController-ExtraPageInfo',
      `${projectId}-EXTRAPAGEINFO`,
    );
  };

  resetObservers = () => {
    if (
      lastPageObserverName
      && window
      && window.nookInfoExchange
      && window.nookInfoExchange.cleanObserver
    ) {
      window.nookInfoExchange.cleanObserver(
        'Context-Page-Params',
        lastPageObserverName,
      );
      this.cleanExtraPageInfoObserver();
    }
  };

  componentDidMount = () => {
    const { context } = this.props;
    const { pageWithExtraInfo } = this.metricsControl;
    // 1) Say hello to cms
    const ping = new PingCmsPage({ context });
    ping.sendPingCmsPage();
    // 2) notify virtual navigation we have changed
    window.nookInfoExchange.sendMessage('SPA-Location', {});
    // 3) handling de pageView because depends on SEO and pageInfo
    this.checkPageChanges();
    // 4) interval checking to know when page is printed
    this.checkFullPagePrint();
    // 5) Aditional info on buyProcess
    if (pageWithExtraInfo) {
      this.checkExtraPageInfo();
    }
    // 6) Check front flat to notify when page is absolutely loaded including services
    this.checkFullLoadedPage();
  };

  shouldComponentUpdate = () => false;

  render() {
    const {
      projectId,
      pageWithExtraInfo,
      seoCustomValue,
      pageId,
      segment,
      match,
    } = this.metricsControl;

    return (
      <Fragment>
        <MetaData
          segment={segment}
          pageWithExtraInfo={pageWithExtraInfo}
          match={match}
          projectId={projectId}
          pageId={pageId}
          seoCustomValue={seoCustomValue}
          onFinish={(seoInfo) => {
            this.metricsControl.seoInfo = seoInfo;
          }}
        />
      </Fragment>
    );
  }
}

Page.propTypes = {
  pageId: PropTypes.string.isRequired,
  isBuyProcess: PropTypes.bool,
};

Page.defaultProps = {
  isBuyProcess: false,
};

export default Page;
